import { setTerm } from './helpers';

export const setIncludeNewMoscow = setTerm('include_new_moscow');
